import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Radio } from 'lucide-react';

const BotonDirecto = ({ activo }) => {
  const navigate = useNavigate();

  if (!activo) return null;

  return (
    <div className="directo-floating-container">
      <button onClick={() => navigate('/sigue-el-reto')} className="directo-btn">
        <div className="status-icons">
          <span className="dot-base"></span>
          <span className="dot-pulse"></span>
        </div>
        <Radio size={16} className="radio-icon" />
        <span className="btn-text">SIGUE A CORREOSO EN DIRECTO</span>
      </button>

      <style jsx>{`
        .directo-floating-container {
          position: fixed;
          top: 85px; /* Ajusta esto según la altura de tu Navbar */
          right: 20px;
          z-index: 1000;
          animation: slideIn 0.5s ease-out;
        }

        @keyframes slideIn {
          from { transform: translateX(100px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }

        .directo-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #ff0055;
          opacity: 0.7;
          color: white;
          border: 2px solid rgba(255, 255, 255, 0.2);
          padding: 8px 16px;
          border-radius: 50px; /* Estilo píldora, más moderno para el top */
          cursor: pointer;
          font-weight: 800;
          font-size: 12px;
          box-shadow: 0 4px 15px rgba(255, 0, 85, 0.3);
          transition: all 0.3s ease;
        }

        .directo-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(255, 0, 85, 0.5);
          background: #ff1a66;
        }

        .status-icons {
          position: relative;
          width: 10px;
          height: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .dot-base {
          width: 6px;
          height: 6px;
          background: white;
          border-radius: 50%;
          z-index: 2;
        }

        .dot-pulse {
          position: absolute;
          width: 100%;
          height: 100%;
          background: white;
          border-radius: 50%;
          animation: pulse-animation 2s infinite;
          opacity: 0.8;
          z-index: 1;
        }

        @keyframes pulse-animation {
          0% { transform: scale(1); opacity: 0.8; }
          100% { transform: scale(3.5); opacity: 0; }
        }

        /* Ajustes para Móvil */
        @media (max-width: 768px) {
          .directo-floating-container {
            top: 75px; /* Un poco más arriba en móvil */
            right: 10px;
          }
          
          .directo-btn {
            padding: 6px 12px;
            font-size: 10px;
          }
        }
      `}</style>

    </div>
  );
};

export default BotonDirecto;